import {Component, OnDestroy, OnInit} from '@angular/core';
import {AccountService, AlertService, UserService} from "../services";
import {ActivatedRoute} from "@angular/router";
import {first} from "rxjs/operators";
import {ServiceService} from "../services/service.service";
import {ComponentTitleService} from "../services/componentTitle.service";

import {locale as polish} from './i18n/pl';
import {locale as english} from './i18n/en';
import {FuseTranslationLoaderService} from "../../../@fuse/services/translation-loader.service";
import {CardOnlineService} from "../services/cardOnline.service";
import {CardOnline} from "../models/cardOnline";
import {Card} from "../models/card";
import {MinusServiceDialogComponent} from "../customer/dialog/minusServiceDialog.component";
import {FormGroup} from "@angular/forms";
import {MatDialog} from "@angular/material/dialog";
import {CardService} from "../services/card.service";
import {ExitCardDialogComponent} from "../customer/dialog/exitCardDialog.component";
import {User} from "../models";
import {CustomerContactDetailsDialogComponent} from "../customer/dialog/customerContactDetailsDialog.component";

@Component({
    templateUrl: './cardOnline.component.html',
    styleUrls: ['./cardOnline.component.scss']
})
export class CardOnlineComponent implements OnDestroy, OnInit {
    card9Expanded: boolean = false;
    view: string = 'preview';
    locale: string = 'pl';
    cards: CardOnline[];
    dialogRef: any;

    constructor(
        private userService: UserService,
        private alertService: AlertService,
        private accountService: AccountService,
        private route: ActivatedRoute,
        private serviceService: ServiceService,
        private componentTitleService: ComponentTitleService,
        private translationLoader: FuseTranslationLoaderService,
        private cardOnlineService: CardOnlineService,
        public _matDialog: MatDialog,
        private cardService: CardService,
    ) {
        componentTitleService.clearTitle();
        componentTitleService.addPart('Users online');

        this.translationLoader.loadTranslations(polish, english);
    }

    ngOnInit() {
        this.cardOnlineService.findAll()
            .pipe(first())
            .subscribe((cards: CardOnline[]) => {
                for (let i = 0; i < cards.length; i++) {
                    this.userService.getById(cards[i].userId).subscribe((res: User) => {
                        cards[i].user = res;
                    });
                }
                this.cards = cards;
            });
    }

    ngOnDestroy(): void {

    }

    openExitCardDialog(card: CardOnline): void {
        this.dialogRef = this._matDialog.open(ExitCardDialogComponent, {
            panelClass: 'exit-card-dialog',
            data      : {
                action : 'show',
                locale: this.locale,
                card: card
            },
            width: '700px',
        });

        this.dialogRef.afterClosed()
            .subscribe((response: FormGroup) => {
                if (!response) {
                    return;
                }

                let data = response.getRawValue();

                this.cardService.exit(card.id, 'WebInterface')
                    .pipe(first())
                    .subscribe(
                        response => {
                            this.cardOnlineService.findAll()
                                .pipe(first())
                                .subscribe((cards: CardOnline[]) => {
                                    this.cards = cards;
                                });
                        },
                        error => {
                            console.log(error);
                        }
                    )

            }, (err) => {
                console.log(err);
            });
    }

    showCustomerContactDetails(customer: User) {
        this.dialogRef = this._matDialog.open(CustomerContactDetailsDialogComponent, {
            panelClass: 'contact-form-dialog',
            data      : {
                action : 'show',
                customer: customer,
            },
            width: '550px',
        });
    }
}
